import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "./ChangePasswordStyle.css";

interface Errors {
  oldPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}

interface State {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
  errors: Errors;
  passwordState: string;
  showPopup: boolean;
  oldPasswordVisible: boolean;
  newPasswordVisible: boolean;
  confirmPasswordVisible: boolean;
}

interface Actions {
  setOldPassword: (v: string) => void;
  setNewPassword: (v: string) => void;
  setConfirmPassword: (v: string) => void;
  toggleOldPasswordVisible: () => void;
  toggleNewPasswordVisible: () => void;
  toggleConfirmPasswordVisible: () => void;
  handlePasswordChange: () => void;
  handleClosePopup: () => void;
}

interface Props {
  state: State;
  actions: Actions;
}

const ChangePasswordView: React.FC<Props> = ({ state, actions }) => {
  return (
    <div className="ja-changepass-container">
      <div className="ja-changepass-header">
        <h2>Passwort ändern</h2>
        <p>Geben Sie Ihr altes Passwort und ein neues Passwort ein.</p>
      </div>

      <div className="ja-changepass-form">
        {/* Altes Passwort */}
        <div className="ja-login-inputContainer">
          <label className="ja-login-label">Altes Passwort</label>
          <div className="ja-login-passwordContainer">
            <input
              className="ja-login-inputBox"
              placeholder="Altes Passwort eingeben"
              type={state.oldPasswordVisible ? "text" : "password"}
              value={state.oldPassword}
              onChange={(e) => actions.setOldPassword(e.target.value)}
            />
            <FontAwesomeIcon
              icon={state.oldPasswordVisible ? faEyeSlash : faEye}
              onClick={actions.toggleOldPasswordVisible}
              className="ja-login-passwordIcon"
            />
          </div>
          {state.errors.oldPassword && (
            <span className="ja-login-errorLabel">{state.errors.oldPassword}</span>
          )}
        </div>

        {/* Neues Passwort */}
        <div className="ja-login-inputContainer">
          <label className="ja-login-label">Neues Passwort</label>
          <div className="ja-login-passwordContainer">
            <input
              className="ja-login-inputBox"
              placeholder="Mindestens 8 Zeichen"
              type={state.newPasswordVisible ? "text" : "password"}
              value={state.newPassword}
              onChange={(e) => actions.setNewPassword(e.target.value)}
            />
            <FontAwesomeIcon
              icon={state.newPasswordVisible ? faEyeSlash : faEye}
              onClick={actions.toggleNewPasswordVisible}
              className="ja-login-passwordIcon"
            />
          </div>
          {state.errors.newPassword && (
            <span className="ja-login-errorLabel">{state.errors.newPassword}</span>
          )}
        </div>

        {/* Passwort bestätigen */}
        <div className="ja-login-inputContainer">
          <label className="ja-login-label">Neues Passwort bestätigen</label>
          <div className="ja-login-passwordContainer">
            <input
              className="ja-login-inputBox"
              placeholder="Neues Passwort wiederholen"
              type={state.confirmPasswordVisible ? "text" : "password"}
              value={state.confirmPassword}
              onChange={(e) => actions.setConfirmPassword(e.target.value)}
            />
            <FontAwesomeIcon
              icon={state.confirmPasswordVisible ? faEyeSlash : faEye}
              onClick={actions.toggleConfirmPasswordVisible}
              className="ja-login-passwordIcon"
            />
          </div>
          {state.errors.confirmPassword && (
            <span className="ja-login-errorLabel">{state.errors.confirmPassword}</span>
          )}
        </div>

        <button
          type="button"
          className="ja-login-primaryButton"
          onClick={actions.handlePasswordChange}
        >
          Passwort speichern
        </button>
      </div>

      {/* Erfolgs-/Status-Overlay im Modal */}
      {state.showPopup && (
        <div className="ja-changepass-successOverlay">
          <div className="ja-changepass-successCard">
            <FontAwesomeIcon icon={faCheckCircle} className="ja-changepass-successIcon" />
            <h3>Status</h3>
            <p>{state.passwordState}</p>
            <button
              type="button"
              className="ja-login-primaryButton"
              onClick={actions.handleClosePopup}
            >
              Schließen
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChangePasswordView;